import { Collection } from '@morningtrain/react-resources'
import { RouteParameterFilter, SelectedDepartmentFilter } from 'support/filters'
import React from 'react'
import { WhenRouteHasParameter } from '@morningtrain/react-navigation'

export default function AvailableSupplierItems ({ children }) {
  return (
    <Collection resourceName='inventory.supplier' operationName='items'>
      <RouteParameterFilter name='inventory_supplier' />
      <WhenRouteHasParameter name='inventory_order'>
        <RouteParameterFilter name='inventory_order' />
      </WhenRouteHasParameter>
      <WhenRouteHasParameter name='inventory_order' negate>
        <SelectedDepartmentFilter />
      </WhenRouteHasParameter>
      {children}
    </Collection>
  )
}
